import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import { reducer as form } from "redux-form";
import escuelas from "../ducks/escuelas";
import inscripciones from "../ducks/inscripciones";
import preinscripciones from "../ducks/preinscripciones";
import confirmadas from "../ducks/confirmadas";
import alumnos from "../ducks/alumnos";
import incidencias from "../ducks/incidencias";
import busquedas from "../ducks/busquedas";
import colegios from "../ducks/colegios";
import cobros from "../ducks/cobros";
import asignaciones from "../ducks/asignaciones";
import actividades from "../ducks/actividades";
import session from "../ducks/login";
import listados from "../ducks/listados";
import ventas from "../ducks/ventas";
import ventasContactos from "../ducks/ventasContactos";
import ventasTareas from "../ducks/ventasTareas";
import ventasCitas from "../ducks/ventasCitas";
import documentacion from "../ducks/documentacion";

const rootReducer = combineReducers({
  form,
  session,
  escuelas,
  inscripciones,
  preinscripciones,
  confirmadas,
  alumnos,
  incidencias,
  busquedas,
  colegios,
  cobros,
  actividades,
  asignaciones,
  listados,
  ventas,
  ventasContactos,
  ventasTareas,
  ventasCitas,
  documentacion
});

const middleware = [thunk];

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const composeEnhancers = compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;



// WEBPACK FOOTER //
// ./src/config/store.js